import { call, put, select, takeEvery } from 'redux-saga/effects'
import { filter, get } from 'lodash'
import { toast } from 'react-toastify'

import MutationApi from '../../remote/mutationApi'

import {
  ADJUST_LINE_ITEM_QUANTITIES,
  adjustLineItemQuantitiesSucceeded,
  adjustLineItemQuantitiesFailed,
} from '../../actions/orders/adjustments'

import { getOrder } from '../../selectors/order'

import { makeOrderLineItem } from '../../utils/orderUtils'
import Log from '../../utils/Log'

const generateUuid = require('uuid/v4')

const prepLineItemAdjustments = (itemData = [], order = {}) => {
  let lineItemsToAdd = []
  let lineItemsToRemove = []

  itemData.forEach(data => {
    const { originalQuantity, quantity } = data

    if (originalQuantity === quantity) return

    // remove line items
    if (originalQuantity > quantity) {
      const quantityToRemove = originalQuantity - quantity
      const matchingLineItems = filter(order.lineItems, (li) => li.menuItemUuid === data.id)

      // TODO would need to handle matching modifiers if we ever allow removing from this flow
      for (let i = 0; i < quantityToRemove; i++) {
        const lineItemToRemove = matchingLineItems[i]
        lineItemsToRemove.push(lineItemToRemove.uuid)
      }

      return
    }

    // add line items
    const newQuantity = quantity - originalQuantity
    for (let i = 0; i < newQuantity; i++) {
      lineItemsToAdd.push({
        ...makeOrderLineItem({
        ...data,
        lineItemUuid: generateUuid(),
      }),
      price: data.price.slice(1),
      },
    )}
  })

  return { lineItemsToAdd, lineItemsToRemove }
}

export function* adjustLineItemQuantities(params = {}) {
  const orderId = get(params, 'payload.orderId')
  const order = yield select(getOrder, orderId)

  const itemData = get(params, 'payload.itemData', [])
  const { lineItemsToAdd, lineItemsToRemove } = prepLineItemAdjustments(itemData, order)
  const reducerParams = { orderId, lineItemsToAdd, lineItemsToRemove }

  try {
    const result = yield call(MutationApi.adjustLineItemQuantities, orderId, lineItemsToAdd, lineItemsToRemove)
    const applied = result?.data?.orderMutations?.[0]?.applied

    if (applied) {
      yield put(adjustLineItemQuantitiesSucceeded({ ...result, ...reducerParams }))
    } 
  } catch (err) {
    yield handleError('Sorry Something Went Wrong', orderId, lineItemsToAdd, lineItemsToRemove, err)
  }
}

export function* watchAdjustLineItemQuantities() {
  yield takeEvery(ADJUST_LINE_ITEM_QUANTITIES, adjustLineItemQuantities)
}

function* handleError(errorMessage, orderId, lineItemsToAdd, lineItemsToRemove, err = {}) {

  Log.error('Adjust Line Item Quantities failed', {
    errorMessage,
    orderId,
    lineItemsToAdd,
    lineItemsToRemove,
  })

  yield put(adjustLineItemQuantitiesFailed({ ...err, orderId, lineItemsToAdd, lineItemsToRemove }))
}
